import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { UserProvider } from './Context/user.context';
import { ActivityProvider } from "./Context/activity.context"
import { ReviewProvider } from './Context/review.context';
import { SaveRoadmapProvider } from "./Context/savedRoadmap.context"
import { RoadmapDetailsProvider } from './Context/fetchRoadmap.context';
import ScrollContainer from './Context/scrollbar.context';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(


    <UserProvider>
      <ReviewProvider>
        <ActivityProvider>
          <SaveRoadmapProvider>
            <RoadmapDetailsProvider>
              <ScrollContainer>
              <App />
              </ScrollContainer>
            </RoadmapDetailsProvider>
          </SaveRoadmapProvider>
        </ActivityProvider>
      </ReviewProvider>
    </UserProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
